import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import Model from 'flarum/common/Model';
/**
 * A reader comment on an article. `content` is the raw markdown source (used to
 * pre-fill the editor); `contentHtml` is the rendered output.
 */
export default class WikiComment extends Model {
  constructor() {
    super(...arguments);
    _defineProperty(this, "content", Model.attribute('content'));
    _defineProperty(this, "contentHtml", Model.attribute('contentHtml'));
    _defineProperty(this, "canEdit", Model.attribute('canEdit'));
    _defineProperty(this, "canDelete", Model.attribute('canDelete'));
    _defineProperty(this, "isDeleted", Model.attribute('isDeleted'));
    _defineProperty(this, "createdAt", Model.attribute('createdAt', Model.transformDate));
    _defineProperty(this, "updatedAt", Model.attribute('updatedAt', Model.transformDate));
    _defineProperty(this, "deletedAt", Model.attribute('deletedAt', Model.transformDate));
    _defineProperty(this, "user", Model.hasOne('user'));
    _defineProperty(this, "article", Model.hasOne('article'));
  }
}
flarum.reg.add('linkrobins-wiki', 'common/models/WikiComment', WikiComment);